<template>
  <div class="cw-main">
    <div class="cw-main_navbar" v-if="title">
      <slot name="navbar">
        <h1 class="active">{{ title }}</h1>
      </slot>
    </div>
    <div class="cw-content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped lang="scss">
.cw-main {
  margin: 20px auto 0;
  width: 100%;
  max-width: 1920px;
  padding-top: 10px;
  padding-bottom: 0;
  padding-left: 120px;
  padding-right: 120px;
  font-family: 'Roboto', sans-serif !important;
  @include font_color('lightWhite8e-font_color');

  @media (max-width: 1580px) {
    padding-left: 80px;
    padding-right: 80px;
  }

  @media (max-width: 1199px) {
    padding-left: 60px;
    padding-right: 60px;
  }

  @media (max-width: 991px) {
    margin: 15px auto 0;
    padding: 5px 15px 0;
  }
}

.cw-main_navbar {
  margin: 20px 0 30px;
  border-bottom: 3px solid $theme-color-light;

  h1 {
    font-size: 1.5rem;
    cursor: default;
    padding: 10px;
    color: $theme-color-dark;
    width: max-content;
    line-height: 25px;
    display: block;
    text-align: center;
    text-decoration: none;
    margin: 0px 8px;
    border: none;
    &.active {
      color: #fff;
      background: $theme-color-gradient;
    }
    @media (max-width: 991px) {
      font-size: 1rem;
    }
  }
}

.cw-content {
  width: 100%;
  margin: 0 auto;
}
</style>
